export default __webpack_public_path__ + "static/media/black-mug.4222a3da.jpeg";